import { Card, Switch, message } from 'antd';
import { useEffect, useState } from 'react';
import { authRequest } from '../../../../../../common/request/authRequest';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';

export const AutomateLabels = () => {

	const [updateData, setUpdateData] = useState(false);
	const [labelsAutomated, setLabelsAutomated] = useState<any>(null);
	const { projectGroup } = useAuth();

	useEffect(() => {
		authRequest(`${process.env.REACT_APP_API}/automated/reviews/${projectGroup.group}/labelsAutomated`, {})
			.then((response) => {
				setLabelsAutomated({ automated: response });
			}).catch(() => { message.error('Error al cargar automatización') });
	}, [updateData]);

	const changeStatus = async (automated: boolean) => {
		const data = {
			project: projectGroup.project,
			automated: automated
		};

		await authRequest(`${process.env.REACT_APP_API}/automated/reviews/${projectGroup.group}/labelsAutomated`, { method: 'PATCH', data: data })
			.then(() => {
				setUpdateData(!updateData);
				message.success('Cambio correcto');
			}).catch(() => {
				message.error('Error imprevisto');
			});
	};

	return (
		<>
			{labelsAutomated &&
				<Card
					className='card-layout'
					bodyStyle={{ padding: '14px 16px' }}
					style={{
						background: '#fff',
						margin: 0,
						marginLeft: 0,
						width: '100%',
						borderRadius: 10,
						border: '1px solid rgba(148, 163, 184, 0.28)',
					}}
				>
					<div style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 12,
					}}>
						<div style={{ minWidth: 0 }}>
							<div style={{
								fontSize: 13,
								fontWeight: 600,
								color: '#0f172a',
								lineHeight: 1.3,
							}}>
								Etiquetado automático
							</div>
							<div style={{
								fontSize: 12,
								color: '#64748b',
								lineHeight: 1.4,
								marginTop: 2,
							}}>
								La IA clasifica las nuevas reseñas según la configuración de tus categorías.
							</div>
						</div>
						<Switch
							className="automate-labels-switch"
							style={{ minWidth: 130 }}
							checkedChildren='Automatizado'
							unCheckedChildren='Manual'
							checked={!!labelsAutomated.automated}
							onClick={(e) => { changeStatus(e) }}
						/>
					</div>
				</Card>
			}
			<style>{`
				.ant-switch.automate-labels-switch.ant-switch-checked {
					background-color: #389e0d !important;
				}
			`}</style>
		</>
	)
}
